import React from "react";
import Header from "./Header";

function HeroLayout({ children }) {
  return (
    <div className="hero">
      <Header />
      {children}
    </div>
  );
}

export default HeroLayout;